import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import Parse from 'parse'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

Vue.use(Parse)
Parse.initialize("bBzZ7wYYGIpQkPPB");
Parse.serverURL = 'https://aircab3.herokuapp.com/parse'
// Parse.initialize("BewIZ9dlh4gNBStm")
// Parse.serverURL = 'https://aircabdev.herokuapp.com/parse'

import router from './router'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {

    var currentUser = Parse.User.current()
    if (currentUser) {
      next()
    } else {
      next('/login')
    }

  } else {
    next() // make sure to always call next()!
  }
})